import { IOCoords } from 'pages/special/OrienteeringPage/OConfig';
import { useRef } from 'react';
import { GiveMeMap, IPinWorldMarker, IViewportExtended } from 'react-give-me-map';
import { MapRef } from 'react-map-gl';
import styled from 'styled-components/macro';

interface Props {
    viewport: IViewportExtended;
    onViewportChange: (viewport: IViewportExtended) => void;
    onCoordinatesChange: (coordinates: IOCoords[]) => void;
    activeCoordinate: number;
    coordinates: IOCoords[];
    className?: string;
}

export const OLeftMap = (props: Props): JSX.Element => {
    const mapRef1 = useRef<MapRef>(null);
    const viewport1 = props.viewport;

    let markers = [];
    markers = [
        ...props.coordinates.map((c, index) => {
            return {
                id: (c.lat + c.lng).toString(),
                lat: c.lat,
                lng: c.lng,
                selectable: true,
                visible: true,
                elementType: 'pin',
                elementData: {
                    label: index.toString(),
                    img: '',
                    emoji: '',
                    dotColor: 'CC4D36',
                    icon: null
                },
                scalable: false,
                order: 2
            } as IPinWorldMarker;
        })
    ];

    return (
        <S_OLeftMap className={props.className}>
            <GiveMeMap
                mapRef={mapRef1}
                map={{
                    ...(viewport1.latitude != null ? { latitude: viewport1.latitude } : {}),
                    ...(viewport1.longitude != null ? { longitude: viewport1.longitude } : {}),
                    ...(viewport1.zoom != null ? { zoom: viewport1.zoom } : {}),
                    mapboxAccessToken: process.env.REACT_APP_MAPBOX_TOKEN,
                    onMove: (v) => {
                        props.onViewportChange({
                            latitude: v.viewState.latitude,
                            longitude: v.viewState.longitude,
                            zoom: v.viewState.zoom
                        });
                    },
                    onClick: (e) => {
                        console.log('Click', e.lngLat);
                        const newCoordinates = [...props.coordinates];
                        newCoordinates[props.activeCoordinate] = {
                            ...newCoordinates[props.activeCoordinate],
                            lat: e.lngLat.lat,
                            lng: e.lngLat.lng
                        };
                        props.onCoordinatesChange(newCoordinates);
                    },
                    onLoad: (e) => {
                        console.log('Load', e);
                    }
                }}
                callbacks={{}}
                markers={markers}
                config={{
                    availableStyles: ['mapbox://styles/koudelka/ckwfq7e5k45h814o8521fnwo1']
                }}
            />
        </S_OLeftMap>
    );
};

const S_OLeftMap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;
